"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDeviceDetect = require("react-device-detect");
var _reactI18next = require("react-i18next");
var _useRefPromise = require("../../../services/useRefPromise");
var _Button = _interopRequireWildcard(require("../Button"));
var _Input = _interopRequireDefault(require("../Input"));
var _Dropdown = require("../Dropdown");
var _Item = require("./components/Item");
var _ItemGroup = require("./components/ItemGroup");
var _MultipleControl = require("./components/MultipleControl");
var _styles = _interopRequireDefault(require("./styles"));
var _check = _interopRequireDefault(require("./check.svg"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var itemsMapper = R.addIndex(R.map);
var StyledDivider = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n"])), function (props) {
  return props.theme.primaryColor;
});
var extractSubItems = function extractSubItems(items) {
  return R.call(R.pipe(R.filter(R.prop('subItems')), R.map(R.prop('subItems')), R.flatten), items);
};
var defaultSearch = function defaultSearch(searchString, item) {
  var content = item.content;
  return R.includes(R.toLower(searchString), R.toLower(content));
};
var noop = function noop() {};
var Select = function Select(_ref) {
  var _activeItem$icon, _activeItem$content;
  var className = _ref.className,
    classNameHeader = _ref.classNameHeader,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    hasError = _ref.hasError,
    itemClassName = _ref.itemClassName,
    items = _ref.items,
    _ref$itemComponent = _ref.itemComponent,
    ItemComponent = _ref$itemComponent === void 0 ? _Item.DefaultItem : _ref$itemComponent,
    _ref$itemGroupCompone = _ref.itemGroupComponent,
    ItemGroupComponent = _ref$itemGroupCompone === void 0 ? _ItemGroup.DefaultItemGroup : _ref$itemGroupCompone,
    label = _ref.label,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    placeholder = _ref.placeholder,
    search = _ref.search,
    value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    onRemove = _ref.onRemove;
  var _useDropdownContext = (0, _Dropdown.useDropdownContext)(),
    isOpen = _useDropdownContext.isOpen,
    open = _useDropdownContext.open,
    close = _useDropdownContext.close,
    toggle = _useDropdownContext.toggle;
  var _useTranslation = (0, _reactI18next.useTranslation)('SELECT_CONTROL'),
    t = _useTranslation.t;
  var searchInputRef = (0, _useRefPromise.useRefPromise)(null);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var deferredSearchString = (0, _react.useDeferredValue)(searchString);
  var activeItem = (0, _react.useMemo)(function () {
    return multiple ? null : R.find(function (_ref2) {
      var own = _ref2.value;
      return R.equals(own, value);
    }, R.concat(items, extractSubItems(items)));
  }, [items, multiple, value]);
  var activeItems = (0, _react.useMemo)(function () {
    if (multiple) {
      var allItems = R.concat(items, extractSubItems(items));
      return R.call(R.pipe(R.map(function (own) {
        return R.find(function (item) {
          return R.equals(item.value, own);
        }, allItems);
      }), R.filter(Boolean)), value);
    }
    return [];
  }, [items, multiple, value]);
  var shouldShowItemsBySearchString = isOpen && deferredSearchString;
  var itemsBySearchString = (0, _react.useMemo)(function () {
    if (shouldShowItemsBySearchString) {
      var isSetCustomSearchMethod = typeof search === 'function';
      var searchMethod = isSetCustomSearchMethod ? search : defaultSearch;
      return R.reduce(function (acc, item) {
        if (Array.isArray(item.subItems)) {
          var subItems = R.filter(R.partial(searchMethod, [deferredSearchString]), item.subItems);
          if (!R.isEmpty(subItems)) {
            acc.push(R.assoc('subItems', subItems, item));
          }
        } else if (searchMethod(deferredSearchString, item)) {
          acc.push(item);
        }
        return acc;
      }, [], items);
    }
    return items;
  }, [deferredSearchString, items, search, shouldShowItemsBySearchString]);
  var onChangeItem = (0, _react.useCallback)(function (item) {
    return function () {
      onChange(item.value, item);
      if (!multiple) {
        close();
      }
      if (search) {
        setSearchString('');
        searchInputRef.getRefPromise().then(function (ref) {
          if (ref) {
            var domNode = ref.current;
            domNode.focus();
          }
        });
      }
    };
  }, [close, multiple, search, searchInputRef, onChange]);
  var onRemoveProxy = (0, _react.useCallback)(function (item) {
    if (onRemove) {
      onRemove(item.value, item);
      var shouldOpenSelect = R.isEmpty(R.filter(function (_item) {
        return _item.value !== item.value;
      }, activeItems));
      if (shouldOpenSelect) {
        open();
      }
    }
  }, [activeItems, open, onRemove]);
  return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    className: className,
    triggerButton: multiple ? /*#__PURE__*/_react.default.createElement(_MultipleControl.MultipleControl, {
      withArrow: true,
      className: classNameHeader,
      isOpen: isOpen,
      isError: hasError,
      items: activeItems,
      label: label,
      searchInputRef: searchInputRef.setRef,
      searchString: searchString,
      onRemove: onRemoveProxy,
      onSearch: !_reactDeviceDetect.isMobileOnly && search ? setSearchString : undefined
    }) : /*#__PURE__*/_react.default.createElement(_Input.default, {
      readOnly: true,
      arrowIcon: disabled ? undefined : {
        rotated: isOpen
      },
      disabled: disabled,
      hasError: hasError,
      icon: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem$icon = activeItem.icon) === null || _activeItem$icon === void 0 ? void 0 : _activeItem$icon.element,
      label: label,
      placeholder: placeholder,
      value: (_activeItem$content = activeItem === null || activeItem === void 0 ? void 0 : activeItem.content) !== null && _activeItem$content !== void 0 ? _activeItem$content : '',
      onClick: disabled ? undefined : toggle
    })
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown.Body, {
    mobileHeaderContent: multiple ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.check,
      icon: _check.default,
      theme: _Button.THEMES.TRANSPARENT,
      onClick: close
    }) : undefined,
    title: label
  }, _reactDeviceDetect.isMobileOnly && search && /*#__PURE__*/_react.default.createElement(_MultipleControl.MultipleControl, {
    isOpen: true,
    className: (0, _classnames.default)(classNameHeader, _styles.default.mobileSearch),
    isError: hasError,
    items: activeItems,
    searchInputRef: searchInputRef.setRef,
    searchString: searchString,
    onRemove: onRemoveProxy,
    onSearch: setSearchString
  }), shouldShowItemsBySearchString && R.isEmpty(itemsBySearchString) && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.noResults
  }, t('EMPTY_STATE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, itemsMapper(function (item, index) {
    return Array.isArray(item.subItems) ? /*#__PURE__*/_react.default.createElement(ItemGroupComponent, {
      content: item.content,
      key: index
    }, itemsMapper(function (itemByGroup, itemIndexByGroup) {
      return /*#__PURE__*/_react.default.createElement(ItemComponent, {
        content: itemByGroup.content,
        disabled: itemByGroup.disabled,
        icon: itemByGroup.icon,
        className: itemClassName,
        key: "sub-item--".concat(itemIndexByGroup),
        selected: multiple ? R.includes(itemByGroup, activeItems) : itemByGroup === activeItem,
        onClick: !itemByGroup.disabled ? onChangeItem(itemByGroup) : noop
      });
    }, item.subItems), item.divider && /*#__PURE__*/_react.default.createElement(StyledDivider, {
      className: _styles.default.divider
    })) : /*#__PURE__*/_react.default.createElement(ItemComponent, {
      content: item.content,
      disabled: item.disabled,
      icon: item.icon,
      className: itemClassName,
      key: index,
      selected: multiple ? R.includes(item, activeItems) : item === activeItem,
      onClick: !item.disabled ? onChangeItem(item) : noop
    });
  }, shouldShowItemsBySearchString ? itemsBySearchString : items), multiple && _reactDeviceDetect.isMobileOnly && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.mobileApply,
    theme: _Button.THEMES.PURPLE,
    onClick: close
  }, t('APPLY_MOBILE_BUTTON')))));
};
var itemPropTypes = {
  content: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.shape({
    element: _propTypes.default.string.isRequired,
    title: _propTypes.default.string
  }),
  // link of original item
  _original: _propTypes.default.any
};
Select.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_objectSpread({}, itemPropTypes, {
    subItems: _propTypes.default.arrayOf(_propTypes.default.shape(_objectSpread({}, itemPropTypes, {
      divider: _propTypes.default.bool
    })))
  }))).isRequired,
  className: _propTypes.default.string,
  classNameHeader: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  itemClassName: _propTypes.default.string,
  itemComponent: _propTypes.default.elementType,
  itemGroupComponent: _propTypes.default.elementType,
  label: _propTypes.default.string,
  multiple: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  search: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  value: _propTypes.default.any,
  onChange: _propTypes.default.func,
  onRemove: _propTypes.default.func
};
var enhancer = R.compose(_Dropdown.withDropdownContext, _react.memo);
var _default = exports.default = enhancer(Select);